import React, { useCallback, useContext, useMemo } from 'react';
import { DateTime } from 'luxon';
import CalendarContext from '../CalendarContext';
import Square from '../Square';
import { Grid } from './styled';
export const getYearRange = (date) => ({
    start: date.year - (date.year % 10) - 1,
    end: date.year - (date.year % 10) + 10,
});
function YearView() {
    const { date, max, min, setDate, setView, value } = useContext(CalendarContext);
    const handleChange = useCallback((year) => {
        setDate(date.set({ year }));
        setView('month');
    }, [date, setDate, setView]);
    const range = useMemo(() => getYearRange(date), [date]);
    const years = useMemo(() => new Array(12).fill('').map((_, index) => {
        const year = range.start + index;
        const key = `year-${year}`;
        const disabled = date.set({ year }).startOf('year') > DateTime.fromJSDate(max) ||
            date.set({ year }).endOf('year') < DateTime.fromJSDate(min);
        const valueDateTime = DateTime.fromJSDate(value);
        const selected = valueDateTime.year === year;
        return (React.createElement(Square, { key: key, disabled: disabled, "$altDisabled": disabled, selected: selected, onClick: () => handleChange(year) }, year));
    }), [date, max, min, range, value, handleChange]);
    return React.createElement(Grid, { view: "year" }, years);
}
export default YearView;
